<template>
  <section id="main-contents">
    <div class="content-title">
      <h1>教科マスタ編集</h1>
    </div>
    <div class="content-wrapper">
      <div class="content-form">
        <form name="subject" method="post" action="">
          <div class="input-wrapper">
            <label for="input-title">教科名<span class="required">*</span></label>
            <input type="text" id="input-title" name="title" maxlength="32" autocomplete="OFF" v-model="title"
                   v-on:change="validTitle"/>
            <p class="error" v-if="this.errors.title !== ''">{{ this.errors.title }}</p>
          </div>
          <div class="input-wrapper">
            <label for="input-remark">備考</label>
            <textarea type="textarea" id="input-remark" name="hp" cols="40" rows="3" v-model="remark" v-on:change="validRemark"/>
            <p class="error" v-if="this.errors.remark !== ''">{{ this.errors.remark }}</p>
          </div>
          <div class="input-wrapper">
            有効フラグ<span class="required">*</span>
            <div class="radio-box">
              <input id="act-1" type="radio" name="activated" value=1 v-model="this.activated" v-on:change="validActivated"/>
              <label for="act-1">有効</label>
              <input id="act-2" type="radio" name="activated" value=2 v-model="this.activated" v-on:change="validActivated"/>
              <label for="act-2">無効</label>
            </div>
            <p class="error" v-if="this.errors.activated !== ''">{{ this.errors.activated }}</p>
          </div>
          <div class="buttons">
            <button class="btn btn-toList" type="button" v-on:click="backToList">一覧に戻る</button>
            <button class="btn btn-submit" type="button" v-on:click="submit">{{ submitText }}</button>
            <button class="btn btn-delete" type="button" v-on:click="deleteCompany" v-if="this.id !== undefined">削除
            </button>
          </div>

          <!--      <button v-else-if="valid" type="button" @click="submit">送信</button>-->
        </form>
      </div>
      <div class="status-detail">
        <table>
          <tr>
            <th></th>
            <th>ユーザー名</th>
            <th>日時</th>
          </tr>
          <tr>
            <th>作成</th>
            <td>{{this.data.CreatedName}}</td>
            <td>{{this.displayDate(this.data.CreatedAt)}}</td>
          </tr>
          <tr>
            <th>編集</th>
            <td>{{this.data.UpdatedName}}</td>
            <td>{{this.displayDate(this.data.UpdatedAt)}}</td>
          </tr>
          <tr>
            <th>削除</th>
            <td>{{}}</td>
            <td>{{this.displayDate(this.data.DeletedAt)}}</td>
          </tr>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
// import connect from "@/config/connect.js"
import axios from "axios";
import authCheck from "@/script/AuthCheck";
import TimeFormatter from "@/script/TimeFormatter";
import store from "@/store";

export default {
  name: 'MainSubjectEdit',
  components: {},
  props: {},
  data: function () {
    return {
      path: '/subject',
      listPath: '/subjects',
      data: {},
      id: 0,
      title: "",
      remark: "",
      activated: undefined,
      errors: {
        title: '',
        remark: '',
        activated: '',
      }
    }
  },
  created: function () {
    this.id = this.$route.query.id
    if (this.id === undefined) {
      // 新規作成の場合通信を行わない
      this.validAll()
    } else {
      // データ編集の場合サーバーに問い合わせを行う
      let path = this.path + '?id=' + this.id
      axios.get(path, {withCredentials: true})
          .then(res => {
            console.log(res.data)
            const router = this.$router
            authCheck(res, router)
            this.data = res.data
            this.title = res.data.Title
            this.remark = res.data.Remark
            this.activated = res.data.Activated
            this.validAll()
          })
          .catch(function (error) {
            console.log(error)
          })
    }
  },
  mounted() {

  },
  computed: {
    submitText: function () {
      if (this.id === undefined) {
        return "新規登録"
      } else {
        return "更新"
      }
    },
  },
  methods: {
    submit: function () {
      // errorがある場合通信を子縄内
      if(this.existErrors()){return}
      let path = this.path
      const params = new URLSearchParams();
      if (this.id === undefined) {
        // 新規作成
        params.append('title', this.title)
        params.append('remark', this.remark)
        params.append('activated', this.activated)
        axios.post(path, params, {withCredentials: true})
            .then(res => {
              if (res.data.result === true) {
                window.alert(this.submitText + "に成功しました")
                this.flashStoreSubjects()
                this.$router.push(this.listPath)
              } else {
                const router = this.$router
                authCheck(res, router)
                window.alert(this.submitText + "に失敗しました")
              }
            })
            .catch(function (error) {
              console.log(error)
              window.alert("通信に失敗しました。もう一度行ってください")
            })
      } else {
        // 更新
        params.append('subject_id', this.id)
        params.append('title', this.title)
        params.append('remark', this.remark)
        params.append('activated', this.activated)
        axios.put(path, params, {withCredentials: true})
            .then(res => {
              if (res.data.result === true) {
                window.alert(this.submitText + "に成功しました")
                this.flashStoreSubjects()
              } else {
                window.alert(this.submitText + "に失敗しました")
              }
            })
            .catch(function (error) {
              console.log(error)
              window.alert("通信に失敗しました。もう一度行ってください")
            })
      }
    },
    existErrors: function (){
      let errors = this.errors
      let flag = false
      Object.keys(errors).forEach(function (key) {
            if (errors[key] !== '') {
              alert(errors[key])
              flag = true;
            }
          }
      )
      return flag
    },
    backToList: function () {
      this.$router.push(this.listPath)
    },
    deleteCompany: function () {
      let result = confirm("本当に削除してよろしいですか？")
      if (!result) {
        return false
      }

      axios.request({
        url: this.path,
        method: 'delete',
        data: {id: Number(this.id), title: this.title, remark: this.remark, activated: this.activated}
      }).then(res => {
        const router = this.$router
        if (res.data.result === true) {
          authCheck(res, router)
          window.alert(this.title + "の削除に成功しました")
          this.flashStoreSubjects()
          this.$router.push(this.listPath)
        } else {
          authCheck(res, router)
          window.alert(this.title + "の削除に失敗しました")
        }
      })
          .catch(function (error) {
            console.log(error)
            window.alert("通信に失敗しました。もう一度行ってください")
          })
    },
    flashStoreSubjects: function (){
      //storeに保存されている教科一覧を削除する
      store.subjects = {}
    },
    displayDate: function (timestamp){
      return TimeFormatter(timestamp)
    },
    validAll: function () {
      this.validTitle()
      this.validRemark()
      this.validActivated()
    },
    validTitle: function () {
      if (this.title.length === 0) {
        let errText = "「教科名」を入力してください"
        this.errors.title = errText
      } else {
        this.errors.title = ''
      }
    },
    validRemark: function () {
      this.errors.remark = ''
    },
    validActivated: function () {
      if (this.activated === undefined) {
        let errText = "有効か無効か選択してください"
        this.errors.activated = errText
      } else {
        this.errors.activated = ''
      }
    }
  }

}
</script>
<style>


</style>